'use client'

import React, { ReactElement } from 'react'
import { Extra } from '@/types/Misc'

import { Image } from '@/components/common/Image'
import { useTranslations } from 'next-intl'

export function HotelExtraModal(props: { extra: Extra; showSubtext?: boolean }): ReactElement {
  const t = useTranslations('Hotel.HotelExtras')
  return (
    <>
      {props.extra.image && props.extra.image !== '' && (
        <Image filename={props.extra.image} width={640} height={360} alt="" />
      )}
      <div className="flex flex-col justify-center p-5">
        <h4 className="mb-2 text-2xl font-bold text-stone-900">{props.extra.name}</h4>
        {props.extra.description && (
          <div
            dangerouslySetInnerHTML={{ __html: props.extra.description }}
            className="prose prose-sm"
          ></div>
        )}
        {props.showSubtext && (
          <p className="mt-4 text-sm italic leading-normal text-stone-800">
            {t('modalSubtext', { extraCost: props.extra.price })}
          </p>
        )}
      </div>
    </>
  )
}
